import React from 'react';
import { ComponentDataTable } from '../../../../components';
import Columns from './Columns';

const DataTable = ({ employees }) => {
  const handleClick = () => {};
  return (
    <ComponentDataTable
      columns={Columns(handleClick)}
      data={employees}
      onRequest={false}
      totalRows={employees.length}
      defaultSortField="full_name"
      pointerOnHover
      sortServer={false}
      paginationServer={false}
      pagination
    />
  );
};

export default DataTable;
